import { PDFDownloadLink } from "@react-pdf/renderer";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";
import { useMemo, useState } from "react";
import { Alert, Button, Spinner } from "react-bootstrap";
import { FaPrint } from "react-icons/fa";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { storage } from "./firebase";
import "./invoice.css";

import { deleteAllCart } from "../product/cartSlice";
import MyDocument from "./MyDocument";

function Invoice() {
  const dt = useParams();
  const [blob, setBlob] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [order, setOrder] = useState(false);
  const cartProduct = useSelector((state) => state.cart.cart);
  const userData = useSelector((state) => state.user.user);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const callfn = async (blob) => {
    setPdfUrl(null);
    // console.log(blob)

    if (Number(cartProduct.length) !== 0 && blob) {
      try {
        const storageRef = ref(storage, `invoice-${dt.time}.pdf`);
        const snapshot = await uploadBytes(storageRef, blob);
        const downloadURL = await getDownloadURL(snapshot.ref);
        localStorage.setItem("url", JSON.stringify(downloadURL));
        const url_Link = await JSON.parse(localStorage.getItem("url"));

        await fetch(
          `${process.env.REACT_APP_SEND_INVOICE}?invoice_No=${dt.time}&pdf_Url=${downloadURL}`,
          {
            mode: "no-cors",
          }
        );

        dispatch(deleteAllCart());
        setOrder(true);
        setPdfUrl(url_Link);

        // console.log("deletedAll", url_Link);
      } catch (err) {
        console.log(err);
      }
    }
    const url_Link = JSON.parse(localStorage.getItem("url"));
    if (localStorage.length) setPdfUrl(url_Link);
  };

  useMemo(() => {
    callfn(blob);
  }, [blob, dt.time]);

  const goBack = () => {
    dispatch(deleteAllCart());
    navigate("/product");
  };

  return (
    <div className="d-flex flex-column  my-3 mb-5 pb-5">
      {order ? (
        <Alert variant="success" className="text-center">
          <Alert.Heading>Your order successfully placed...</Alert.Heading>
          <p>
            Thanks for purchasing in Awesome Crackers. We will contact you soon.
          </p>
        </Alert>
      ) : (
        <div className="d-flex flex-column align-items-center justify-content-center gap-2">
          {/* <Spinner animation="border" role="status" variant="success" /> */}
          <h4 className="fw-bold text-success my-2">
            Please wait while we process your invoice
          </h4>
        </div>
      )}

      <PDFDownloadLink
        className="mb-2"
        document={<MyDocument dt={dt} item={cartProduct} user={userData} />}
        fileName="AwesomeInvoice.pdf"
      >
        {({ blob, url, loading }) =>
          loading ? (
            <div>
              {!order && (
                <div className="text-center my-4">
                  <Spinner animation="border" role="status" variant="success" />
                  <div className="mt-2">Preparing invoice...</div>
                </div>
              )}
            </div>
          ) : (
            <div onClick={setBlob(blob)} />
          )
        }
      </PDFDownloadLink>

      {pdfUrl ? (
        <div className="text-center my-3">
          <h2 className="fw-bold my-2 mb-3">Download PDF Invoice</h2>
          <br />
          <a href={pdfUrl} download="invoice" target="_blank" rel="noreferrer">
            <Button className="bg-secondary fw-bold border-0 px-3 fs-5">
              <FaPrint /> &nbsp; Invoice PDF file
            </Button>
          </a>
        </div>
      ) : (
        <div className="text-center my-4">
          <Spinner animation="border" role="status" variant="success" />
          <div className="mt-2">Preparing invoice...</div>
        </div>
      )}

      <br />

      {pdfUrl ? (
        <div>
          <Button
            variant="danger px-5 mb-5 fs-5 fw-lighter"
            onClick={() => goBack()}
          >
            Back
          </Button>
        </div>
      ) : (
        <div>
          <Button
            variant="danger px-5 mb-5 fs-5 fw-lighter"
            onClick={() => goBack()}
          >
            Don't Go Back
          </Button>
        </div>
      )}
    </div>
  );
}

export default Invoice;
